<div class="container-details">
  <div class="container-details__header">
    <div style="width: 100%">{{ container?.containerNo }}</div>
    <a (click)="detailsClosed.emit()" class="material-symbols-outlined container-details__header--close">close</a>
  </div>
  <mat-tab-group class="container-details__tab-group" (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Details">
      <ng-template mat-tab-label><span class="material-symbols-outlined">info</span>DETAILS</ng-template>
      <app-details [container]="container" [isArchived]="isArchived"></app-details>
      <app-purchase-order-list [orders]="container?.purchaseOrders"></app-purchase-order-list>
      <app-routing [item]="container"></app-routing>
    </mat-tab>
    @if (!isArchived) {
      <mat-tab label="Custom Fields">
        <ng-template mat-tab-label><span class="material-symbols-outlined">tune</span>CUSTOM FIELDS</ng-template>
        <app-custom-fields [item]="container" [openedFrom]="'Container'"></app-custom-fields>
      </mat-tab>
    }
    <mat-tab label="All Events">
      <ng-template mat-tab-label><span class="material-symbols-outlined">flag_check</span>ALL EVENTS</ng-template>
      <app-last-event [item]="container"></app-last-event>
      <app-all-events [item]="container"></app-all-events>
    </mat-tab>
  </mat-tab-group>
</div>
